import React from "react";
import { createUseStyles } from "react-jss";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import { SVGArrowDownMini, SVGArrowUpMini } from "Constants/SVG";

const useStyles = createUseStyles((theme) => ({
	root: {
		display: "block",
		fontFamily: "Inter-SemiBold",
		color: "#111827",
		fontSize: "14px",
		lineHeight: "20px",
		cursor: "default",
		width: "100%",
	},
	link: {
		cursor: "pointer",
		"&:hover": {
			color: "#65A3FF",
		},
	},
	button: {
		display: "flex",
		alignItems: "center",
		cursor: "pointer",
		"& svg": {
			fill: "CurrentColor",
		},
		"&:hover": {
			color: "#65A3FF",
		},
	},
	text: {
		marginRight: "6px",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			fontSize: "12px",
			lineHeight: "16px",
		},
	},
}));

const FooterTopTitle = (props) => {
	const { isLink, isButton, clickHandler, text, isOpen, src } = props;
	const classes = useStyles();

	return (
		<>
			{isLink ? (
				<Link className={classNames(classes.root, classes.link)} to={src}>
					{text}
				</Link>
			) : isButton ? (
				<div className={classNames(classes.root, classes.button)} onClick={clickHandler}>
					<div className={classes.text}>{text}</div>
					{isOpen ? (
						<svg
							width="10"
							height="6"
							viewBox="0 0 10 6"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d={SVGArrowUpMini} />
						</svg>
					) : (
						<svg
							width="10"
							height="6"
							viewBox="0 0 10 6"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d={SVGArrowDownMini} />
						</svg>
					)}
				</div>
			) : (
				<div className={classes.root}>{text}</div>
			)}
		</>
	);
};

FooterTopTitle.propTypes = {
	isLink: PropTypes.bool,
	isButton: PropTypes.bool,
	clickHandler: PropTypes.func,
	text: PropTypes.string,
	isOpen: PropTypes.bool,
};
export default FooterTopTitle;
